import { AsyncPipe } from '@angular/common';
import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { DeviceStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { DeviceState } from '@rocksoft/locations-sdk';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { DeviceBadgeState, DevicesStateBadgeComponent } from './devices-state-badge.component';

function deviceStateFor(state: DeviceBadgeState): DeviceState {
  return state === 'unassigned' ? DeviceState.Unassigned : DeviceState.Unavailable;
}

@Component({
  selector: 'era-devices-state-badge',
  templateUrl: './devices-state-badge.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DevicesStateBadgeComponent, AsyncPipe],
})
export class DevicesStateBadgeContainerComponent {
  private readonly deviceStore = inject(Store);

  private readonly stateSubject = new BehaviorSubject<DeviceBadgeState>('unassigned');

  readonly stateInput = input.required<DeviceBadgeState>();

  public readonly state$ = this.stateSubject.asObservable();
  public readonly count$: Observable<number | undefined>;

  constructor() {
    effect(() => {
      const value = this.stateInput();
      if (value) this.stateSubject.next(value);
    });

    this.count$ = this.stateSubject.pipe(
      switchMap((badgeState) =>
        this.deviceStore.select(DeviceStoreSelectors.selectDevicesCountByState(deviceStateFor(badgeState)))
      )
    );
  }
}
